import React, { useState } from "react";
import doctorImage from "../../Images/dr.anant.png"; // Replace with correct image
import { HiAcademicCap } from "react-icons/hi2";
import { IoIosCall } from "react-icons/io";
import { BsCalendarCheck } from "react-icons/bs";
import {
  FaLinkedinIn,
  FaFacebookF,
  FaTwitter,
  FaInstagramSquare,
  FaFacebookSquare,
  FaLinkedin,
} from "react-icons/fa";
import Pageslide from "../../commanfile/Pageslide";
import pageslides from "../../Images/cover.jpg";
import ServiceImages from "../../commanfile/ServiceImages";
import Review from "../../commanfile/Review";
import { GrYoutube } from "react-icons/gr";

const Doctor = () => {
  return (
    <>
      <div className="max-w-[1456px] mx-auto">
        <div className="mx-auto ">
          <Pageslide name={""}
            imgaes={pageslides}
            className={"w-[100%] lg:h-[700px] pt-3  sm:w-[100%]"}
          />
        </div>
        <div className=" bg-white flex justify-center md::py-10 py-5">
          <div className="w-[1200px] md:flex flex-wrap rounded-xl overflow-hidden ">
            {/* Right: Info */}
            <div className="w-[100%] sm:w-[60%] py-10 sm:px-10 px-5">
              <h1 className="text-4xl  font-sans font-bold text-[#469B8F]">
                Dr. Anant Changela
                <p className="text-xl pt-2  font-sans font-bold text-[#469B8F]">
                  M.D. Neuropsychiatry[FIPS]
                </p>
              </h1>
              <p className="text-sm  text-gray-600 mt-1">
                Board-certified Psychiatrist
              </p>
              <p className="text-base text-gray-700 mt-6  text-justify">
                Dr. Anant Changela is a distinguished consultant MD
                Neuro-Psychiatrist & De-addiction Specialist. He believes in a
                multidisciplinary personalized strength-based approach. A
                dedicated member of the Indian Psychiatric Society, actively
                involved in mental health advocacy.
              </p>

              <p className="text-base text-gray-700 mt-6  text-justify">
                His goal is to break the stigma around mental health and create
                a safe space for healing and growth. He works closely with
                patients, families, and caregivers to create customized
                treatment plans that combine clinical therapy with emotional
                support.
              </p>

              {/* Degrees */}
              <div className="mt-6 ">
                <h3 className="text-xl font-semibold text-[#469B8F] flex items-center gap-2">
                  <HiAcademicCap /> Degrees
                </h3>
                <ul className="list-disc ml-6 mt-2 text-base space-y-1 text-[#469B8F] ">
                  <li>
                    M.B.B.S.
                    <div className="text-xs text-gray-500">
                      GMERS Medical College & Civil Hospital, Valsad
                    </div>
                  </li>
                  <li>
                    M.D. Psychiatry
                    <div className="text-xs text-gray-500">
                      SMMIMER Hospital, Surat
                    </div>
                  </li>
                  <li>Fellow in Indian Psychiatry Society</li>
                  <li>Sr. Resident Psychiatrist at SMMIMER Hospital, Surat</li>
                </ul>
              </div>

              {/* Social Icons */}
              <div className="mt-6 flex gap-4 pl-2">
<a href="https://www.instagram.com/psynexa_/">
                  <FaInstagramSquare className="text-3xl rounded-xl text-[#E4405F]" />
                </a>
                <a href="https://www.facebook.com/share/15G9kb7Wfb/?mibextid=wwXIfr">
                  <FaFacebookSquare className="text-3xl rounded-xl text-[#3B5998] " />
                </a>
                <a href="https://www.youtube.com/@dranantchangela">
                  <GrYoutube className="text-3xl rounded-xl text-[#FF0000]" />
                </a>
                <a href="https://www.linkedin.com/in/dr-anant-changela-9a5312363">
                  <FaLinkedin className="text-3xl rounded-xl text-[#0077B5]" />
                </a>
              </div>
            </div>
            <div className="w-[100%] sm:w-[40%]  bg-[#e7f2f2] flex flex-col items-center py-10 px-4">
              <img
                src={doctorImage}
                alt="Doctor"
                className="w-[340px] h-[360px] object-cover rounded-md shadow mb-6"
              />
              <p className="bg-[#469B8F] text-white px-6 py-2 rounded-md font-medium">
                Psychiatry Specialist
              </p>

              {/* Contact Info */}
              <div className="mt-8 w-full px-4 space-y-6 text-[#333]">
                <div>
                  <h4 className="flex items-center gap-2 font-semibold text-[#469B8F]">
                    <IoIosCall /> Contact Info
                  </h4>
                  <p className="text-base mt-1">+91 85758 88887</p>
                  <p className="text-base">Dr.Anant@psynexa.in</p>
                </div>

                <div>
                  <h4 className="flex items-center gap-2 font-semibold text-[#469B8F]">
                    <BsCalendarCheck /> Appointment Schedules
                  </h4>
                  <p className="text-sm mt-1">By Request</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="">
          <div className="mx-auto pl-[40px] pr-[40px]">
            <p className=" text-base text-center underline">MENTAL HELTH SERVICES</p>
            <p className=" text-4xl mt-3 text-center font-roboto font-bold">
              Our Specializations
            </p>
          </div>

          <div className="mt-4">
            <ServiceImages />
          </div>
        </div>



        <div className="mt-8 py-6">
          <div className=" my-8 ">
            <div className="mx-auto py-4">
              <p className="text-center text-xl sm:text-3xl font-serif font-thin text-slate-700 mb-5 leading-10 uppercase ">that's what our patients say</p>
              <div className="border-b-4 border-dashed border-[#469B8F] md:w-[50%] w-[90%] mx-auto"> </div>
            </div>
            <Review />
          </div>
        </div>

      </div>
    </>
  );
};

export default Doctor;
